import { getAsync, postAsync } from './_base';

const getStateList = (countryValue: string, apiUrl: string) => {
  const data = new FormData();
  data.append('country', countryValue);

  return postAsync(apiUrl, undefined, data, undefined, undefined, true);
};

const getDeliveryRegions = (countryValue: string, apiUrl: string) => {
  const data = new FormData();
  data.append('country', countryValue);
  return postAsync(apiUrl, undefined, data, undefined, undefined, true);
};

const getShippingMethods = (apiUrl: string) => {
  return getAsync(apiUrl);
};

const checkInAccessRegion = (countryValue: string, apiUrl: string, currentUrl?: string) => {
  return postAsync(apiUrl, undefined, { country: countryValue, currentUrl: currentUrl ?? location.href });
};

const checkVATValid = (countryValue: string, vatNumber: string, apiUrl: string) => {
  return postAsync(apiUrl, undefined, { countryCode: countryValue, vatNumber: vatNumber });
};

export { getStateList, getDeliveryRegions, getShippingMethods, checkInAccessRegion, checkVATValid };
